import { JsonLd } from "./JsonLd";

import type { JSX } from "react";

// // // //

export interface WebPageSEOProps {
    /** Absolute URL - build it with `addBaseUrl()`. */
    id: string;
    description?: string;
    /** ISO-8601 timestamp. */
    lastReviewed?: string;
    reviewedBy?: {
        type?: string;
        name: string;
    };
}

/**
 * WebPageSEO
 * Renders WebPage JSON-LD.
 *
 * NOTE - replaces next-seo's `WebPageJsonLd`, which renders through `next/head`
 * and therefore emits nothing in the App Router. Same payload, same key order.
 */
export function WebPageSEO(props: WebPageSEOProps): JSX.Element {
    const { id, description, lastReviewed, reviewedBy } = props;

    return (
        <JsonLd
            data={{
                "@context": "https://schema.org",
                "@type": "WebPage",
                ...(description ? { description } : {}),
                ...(lastReviewed ? { lastReviewed } : {}),
                ...(reviewedBy
                    ? {
                          reviewedBy: {
                              "@type": reviewedBy.type ?? "Organization",
                              name: reviewedBy.name,
                          },
                      }
                    : {}),
                "@id": id,
            }}
        />
    );
}
